import React from 'react'
import AddAgencyBreadCrumb from './AddAgencyBreadCrumb' ;
import AddRenewableAgency from './AddRenewableAgency';
function AddRenewableAgencyPage() {
    return ( 
        <div className= "container-fluid">
            <AddAgencyBreadCrumb />
            <AddRenewableAgency />
        </div>
     );
}

export default AddRenewableAgencyPage;